import {
    DeliveryDining,
    Drafts,
    LocalDining,
    Microwave,
    Outbox,
    Receipt,
    SoupKitchen,
} from "@mui/icons-material";
import { Tooltip } from "@mui/material";

const OrderStatusIcon = ({ status }) => {
    const getStatusIcon = (status) => {
        switch (status) {
            // case "Attending":
            // return <Drafts fontSize="small" />;
            case "Sent":
                return <Outbox fontSize="small" />;
            case "Processing":
                return <Microwave fontSize="small" />;
            case "Completed":
                return <SoupKitchen fontSize="small" />;
            case "Delivering":
                return <DeliveryDining fontSize="small" />;
            case "Delivered":
                return <LocalDining fontSize="small" />;
            case "Invoiced":
                return <Receipt fontSize="small" />;
            default:
                return null;
        }
    };

    const getTooltipDetails = (status) => {
        switch (status) {
            case "Attending":
                return "";
            // return "Pending";
            case "Sent":
                return "Sent to kitchen";
            case "Processing":
                return "Order processing";
            case "Completed":
                return "Order completed and waiting!";
            case "Delivering":
                return "Delivering order to table";
            case "Delivered":
                return "On table";
            case "Invoiced":
                return "Item invoiced.";
            default:
                return null;
        }
    };

    return (
        getStatusIcon(status) && (
            <Tooltip title={getTooltipDetails(status)} placement="top">
                {getStatusIcon(status)}
            </Tooltip>
        )
    );
};

export default OrderStatusIcon;
